export default __webpack_public_path__ + "static/media/icon-menu-jd-active.a199a931.svg";